import { render, staticRenderFns } from "./SaleHistoryEventEmailRead.vue?vue&type=template&id=b8316954&scoped=true"
import script from "./SaleHistoryEventEmailRead.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventEmailRead.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistoryEventEmailRead.vue?vue&type=style&index=0&id=b8316954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8316954",
  null
  
)

export default component.exports